/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * @deprecated enum: This will be removed in a future release, please migrate away from it as soon as possible.
 */
export const UnderwritingStatus = {
  Approved: "approved",
  Rejected: "rejected",
  PendingReview: "pendingReview",
  Pending: "pending",
  NotRequested: "notRequested",
} as const;
/**
 * @deprecated enum: This will be removed in a future release, please migrate away from it as soon as possible.
 */
export type UnderwritingStatus = ClosedEnum<typeof UnderwritingStatus>;

/** @internal */
export const UnderwritingStatus$inboundSchema: z.ZodNativeEnum<
  typeof UnderwritingStatus
> = z.nativeEnum(UnderwritingStatus);
/** @internal */
export const UnderwritingStatus$outboundSchema: z.ZodNativeEnum<
  typeof UnderwritingStatus
> = UnderwritingStatus$inboundSchema;
